<template>
    <v-container fill-height fluid class="sign-in">
        <v-layout align-center justify-center>
            <v-flex xs12 sm8 md4 elevation-6>
                <v-card class="elevation-12 pa-4" color="grey lighten-5">
                    <v-card-text>
                        <v-container>
                            <v-layout row justify-space-between>
                                <v-flex xs6>
                                    <img height="70" :src="clinicLogo" />
                                </v-flex>
                                <v-flex xs6 align-self-end>
                                    <div class="text-right">
                                        <img height="90" :src="sipLogin" />
                                    </div>
                                </v-flex>
                            </v-layout>

                            <v-layout row>
                                <v-flex xs12>
                                    <div class="tw-gray headline font-weight-medium">
                                        <p></p>Inicio de Sesión
                                    </div>
                                </v-flex>
                            </v-layout>
                            <v-layout row v-if="failedLogin">
                                <v-alert
                                    width="100%"
                                    outlined
                                    dense
                                    type="error"
                                >Usuario o contraseña no válidos.</v-alert>
                            </v-layout>

                            <v-layout row justify-space-around>
                                <v-flex xs12>
                                    <v-form ref="form" v-model="valid" @submit.prevent>
                                        <v-container>
                                            <v-layout row justify-space-around>
                                                <v-flex xs11 sm10 md9>
                                                    <v-text-field
                                                        color="indigo darken-3"
                                                        prepend-icon="person"
                                                        name="email"
                                                        label="Correo Electrónico"
                                                        type="email"
                                                        v-model="email"
                                                        :rules="emailRules"
                                                        required
                                                        align-self-center
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row justify-space-around>
                                                <v-flex xs11 sm10 md9>
                                                    <v-text-field
                                                        color="indigo darken-3"
                                                        prepend-icon="lock"
                                                        name="password"
                                                        label="Contraseña"
                                                        id="password"
                                                        type="password"
                                                        required
                                                        v-model="password"
                                                        :append-icon="
                                              e1 ? 'visibility_off' : 'visibility'
                                          "
                                                        @click:append="() => (e1 = !e1)"
                                                        :type="e1 ? 'password' : 'text'"
                                                        :rules="passwordRules"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row>
                                                <v-spacer></v-spacer>
                                                <v-spacer></v-spacer>

                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    type="submit"
                                                    @submit.prevent="checkLogin"
                                                    @click="onSubmit"
                                                    :class="{
                                        'indigo darken-3 white--text': valid,
                                        disabled: !valid
                                      }"
                                                >OK</v-btn>
                                            </v-layout>
                                        </v-container>
                                    </v-form>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-footer absolute color="black" dark>
            <v-spacer></v-spacer>
            <div>&copy; Grupo Tecnológico Santa Fe, S.A. de C.V. {{ new Date().getFullYear() }}</div>
        </v-footer>
    </v-container>
</template>


<script>
import { mapGetters } from 'vuex';
export default {
    data() {
        return {
            valid: false,
            e1: true,
            password: '',
            passwordRules: [v => !!v || 'Introduzca la contraseña'],
            email: '',
            emailRules: [
                v => !!v || 'Introduzca su correo electrónico',
                v =>
                    /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                    'Introduzca un correo válido'
            ]
        };
    },
    methods: {
        onSubmit() {
            if (this.$refs.form.validate()) {
                this.$store.dispatch('login', {
                    email: this.email,
                    password: this.password
                });
            }
        },
        clear() {
            this.$refs.form.reset();
        }
    },
    computed: {
        ...mapGetters(['clinicLogo', 'sipLogin']),
        failedLogin() {
            return this.$store.getters.failedLogin;
        },
        waitCursor() {
            return this.$store.getters.waitCursor;
        }
    },
    created() {
        this.$store.dispatch('tryAutoLogin');
    }
};
</script>

<style scoped>
.sign-in {
    background: url('../assets/background1.png');
    background-size: cover;
    width: 100%;
    height: 100%;
}

.sip-blue {
    color: #283593;
    /* indigo darken-3 */
}

.tw-gray {
    color: #757575;
    /* grey darken-1 */
}
</style>
